'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function AmindSmile(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M512 64c247.136 0 448 200.864 448 448s-200.864 448-448 448S64 759.136 64 512 264.864 64 512 64z m0 832c211.968 0 384-172.032 384-384S723.968 128 512 128 128 300.032 128 512s172.032 384 384 384zM288 416a64 64 0 1 1 128 0 64 64 0 0 1-128 0z m320 0a64 64 0 1 1 128 0 64 64 0 0 1-128 0z m50.368 196.8a30.72 30.72 0 0 1 8.928 41.824A182.048 182.048 0 0 1 512 741.344a182.048 182.048 0 0 1-155.296-86.72 30.72 30.72 0 0 1 8.96-41.824 29.44 29.44 0 0 1 41.024 9.088 123.68 123.68 0 0 0 210.624 0 29.44 29.44 0 0 1 41.056-9.088z' })
  );
}
AmindSmile.displayName = 'AmindSmile';

module.exports = AmindSmile;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/amindSmile.js
// module id = 146
// module chunks = 0